import React, { useEffect, useRef } from "react"
import { useStore } from "@/store"
import { getHoursWrapped } from "@/components/calendar_view/_utils"
import { Clock3 } from "lucide-mui"

const QUARTER_LINES = [1, 2, 3] // 15min, 30min, 45min marks within each hour

const HOUR_LINE_COLOR = "#d1d5db"
const QUARTER_LINE_COLOR = "#e5e7eb"

const TimelineLayer = ({ startHour, endHour, mainCanvasRef }) => {
  const { calendarDimensions } = useStore()
  const hours = getHoursWrapped(startHour, endHour)
  const timelineRef = useRef(null)

  useEffect(() => {
    if (mainCanvasRef.current && timelineRef.current) {
      const canvas = mainCanvasRef.current

      const onScroll = () => {
        timelineRef.current.style.top = `-${mainCanvasRef.current.scrollTop}px`
      }

      onScroll()
      canvas.addEventListener("scroll", onScroll)

      return () => canvas.removeEventListener("scroll", onScroll)
    }
  }, [mainCanvasRef, timelineRef, calendarDimensions.timeline.top])

  const offset = calendarDimensions.timeline.offset
  const quarterHeight = offset / 4

  return (
    <div
      className="absolute flex-1 flex-row min-w-min touch-none pointer-events-none"
      style={{
        top: calendarDimensions.timelineContainer.top,
        left: 0,
        width: calendarDimensions.timelineContainer.width,
        height: calendarDimensions.timelineContainer.height,
        overflow: "hidden",
      }}
    >
      <div
        ref={timelineRef}
        className="absolute flex-1 flex-row min-w-min touch-none pointer-events-none"
        style={{
          paddingTop: calendarDimensions.timeline.top,
          left: 0,
          width: calendarDimensions.timeline.width,
          height: calendarDimensions.timeline.height,
          zIndex: 5,
        }}
      >
        <div
          className="absolute top-0 flex items-center justify-center border-0 border-r border-b border-solid border-gray-300 bg-gray-200"
          style={{
            width: calendarDimensions.timeline.columnWidth,
            height: calendarDimensions.tableGroupLabelHeight + calendarDimensions.tableLabelHeight,
          }}
          data-testid="panel-reservations-calendar-timeline-header"
        >
          <Clock3 className="w-6 h-6 text-gray-400" style={{ strokeWidth: 1.75 }} />
        </div>
        {hours.map((hour) => (
          <div
            key={hour}
            className="relative flex-1 leading-none"
            style={{ height: offset }}
            data-testid={`panel-reservations-calendar-timeline-hour-${hour}`}
          >
            <div
              className="absolute left-0 flex items-center justify-end pr-1.5 text-sm font-normal text-gray-400"
              style={{
                top: 0,
                width: calendarDimensions.timeline.columnWidth,
                height: offset,
              }}
            >
              {hour}:00
            </div>
            <div
              className="absolute left-0 border-0 border-b border-solid"
              style={{
                top: offset / 2,
                left: calendarDimensions.timeline.columnWidth,
                width: `calc(100% - ${calendarDimensions.timeline.columnWidth}px)`,
                borderColor: HOUR_LINE_COLOR,
              }}
            />
            {QUARTER_LINES.map((q) => {
              const top = offset / 2 + q * quarterHeight

              return (
                <div
                  key={q}
                  className="absolute left-0 border-0 border-b border-dotted pointer-events-none"
                  style={{
                    top,
                    left: calendarDimensions.timeline.columnWidth,
                    width: `calc(100% - ${calendarDimensions.timeline.columnWidth}px)`,
                    borderColor: QUARTER_LINE_COLOR,
                  }}
                />
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}

export default TimelineLayer
